import React, { useEffect, useState } from 'react';
export function AnimatedBackground() {
  const [pokeballs, setPokeballs] = useState([]);
  useEffect(() => {
    // Create initial pokeballs
    const initialPokeballs = Array.from({
      length: 15
    }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      delay: Math.random() * 20,
      size: Math.random() * 30 + 20,
      speed: Math.random() * 10 + 10 // random speed (10-20s)
    }));
    setPokeballs(initialPokeballs);
  }, []);
  return <div className="fixed inset-0 w-full h-full overflow-hidden pointer-events-none z-0" data-id="element-32">
      {pokeballs.map(ball => <div key={ball.id} className="absolute animate-fall opacity-20" style={{
      left: `${ball.x}%`,
      width: `${ball.size}px`,
      height: `${ball.size}px`,
      animationDuration: `${ball.speed}s`,
      animationDelay: `${ball.delay}s`
    }} data-id="element-33">
          <div className="w-full h-full relative" data-id="element-34">
            <div className="absolute inset-0 rounded-full bg-red-600 border-2 border-black" data-id="element-35"></div>
            <div className="absolute inset-0 rounded-full bg-white border-2 border-black" style={{
          clipPath: 'polygon(0 50%, 100% 50%, 100% 100%, 0 100%)'
        }} data-id="element-36"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1/3 h-1/3 rounded-full bg-white border-2 border-black" data-id="element-37"></div>
          </div>
        </div>)}
    </div>;
}